// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportSubscriptionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//
/**
 * ReportSubscriptionConstants
 */

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get SUBSCRIPTION_REPORT() {
    return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_REPORT');
  },
  CUSTOM_RECURRENCE: '8',
  EMAIL_SUBJECT: {
    REPORT: '{reportName}',
    DASHBOARD: '{dashboardName}'
  },
  MESSAGE: {
    get M01a() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_DELETE_INSTANCE');
    },
    get M01b() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_DELETE_SELECTED_INSTANTCES');
    },
    get M03a() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_END_DATE_CANNOT_PRIOR_CURRENT_DATE');
    },
    get M03b() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_START_DATE_CANNOT_AFTER_END_DATE');
    },
    get M04() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_CANNOT_BE_SUBSCRIBE');
    },
    get M05() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_NAME_EXIST');
    },
    get M06() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_ADJUSTED_ACCORDINGLY');
    },
    get requiredOccurrence() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_MESSAGE_REQUIRED_OCCURRENCE');
    }
  },
  TABLE_DEF: {
    selectedValue: {
      key: 'selectedValue',
      width: 30,
      title: '',
      sortable: false
    },
    name: {
      key: 'name',
      width: 200,
      get title() {
        return localizer.getText('COMMON_LABEL_INSTANCE_NAME');
      },
      sortable: true,
      columnKey: 'name'
    },
    schedule: {
      key: 'schedule',
      width: 220,
      get title() {
        return localizer.getText('COMMON_LABEL_SCHEDULE');
      },
      sortable: true,
      columnKey: 'schedule'
    },
    filterValueSelection: {
      key: 'filterValueSelection',
      width: 100,
      get title() {
        return localizer.getText('COMMON_LABEL_FILTER_VALUE_SELECTION');
      },
      sortable: true,
      columnKey: 'filterValueSelection'
    },
    deliveryType: {
      key: 'deliveryType',
      width: 80,
      get title() {
        return localizer.getText('COMMON_LABEL_DELIVERY_TYPE');
      },
      sortable: true,
      columnKey: 'deliveryType'
    },
    deliveryMethodView: {
      key: 'deliveryMethodView',
      width: 150,
      get title() {
        return localizer.getText('COMMON_LABEL_DELIVERY_METHOD');
      },
      sortable: true,
      columnKey: 'deliveryMethodView'
    },
    action: {
      key: 'action',
      width: 80,
      get title() {
        return localizer.getText('COMMON_LABEL_ACTION');
      },
      sortable: false,
      fixed: true
    }
  },
  PAGE_TEXT: {
    get AddText() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_ADD');
    },
    get EditText() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_EDIT');
    },
    get CopyText() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_COPY');
    },
    get DeleteText() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_DELETE');
    }
  },
  SEARCH_OPTION: [
    {
      value: 'All',
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: 'Name',
      get label() {
        return localizer.getText('COMMON_LABEL_INSTANCE_NAME');
      }
    },
    {
      value: 'Schedule',
      get label() {
        return localizer.getText('COMMON_LABEL_SCHEDULE');
      }
    },
    {
      value: 'FilterValueSelection',
      get label() {
        return localizer.getText('COMMON_LABEL_FILTER_VALUE_SELECTION');
      }
    },
    {
      value: 'DeliveryType',
      get label() {
        return localizer.getText('COMMON_LABEL_DELIVERY_TYPE');
      }
    },
    {
      value: 'DeliveryMethod',
      get label() {
        return localizer.getText('COMMON_LABEL_DELIVERY_METHOD');
      }
    }
  ],

  DEFAULT_VALUE: {
    get SEARCH_CRITERIA() {
      return localizer.getText('COMMON_LABEL_ALL');
    },
    SORT_DIRS: {
      name: 'DESC'
    }
  },

  SUBSCRIPTION_TYPE: [
    {
      value: 'Subscribed Reporting Item',
      get label() {
        return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_TYPE_REPORTING_ITEM');
      }
    },
    {
      value: 'Subscribed Alert',
      get label() {
        return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_TYPE_ALERT');
      }
    }
  ],

  EXPORT_TYPE: [
    {
      value: 'Word',
      label: 'Word'
    },
    {
      value: 'Excel',
      label: 'Excel'
    },
    {
      value: 'PDF',
      label: 'PDF'
    },
    {
      value: 'CSV',
      label: 'CSV'
    },
    {
      value: 'XML',
      label: 'XML'
    },
    {
      value: 'JSON',
      label: 'JSON'
    }
  ],

  DELIVERY_TYPE: [
    {
      value: 'Email',
      get label() {
        return localizer.getText('COMMON_LABEL_EMAIL');
      },
      deliveryMethod: [
        {
          value: 'Link',
          get label() {
            return localizer.getText('COMMON_LABEL_LINK');
          }
        },
        {
          value: 'Attachment',
          get label() {
            return localizer.getText('COMMON_LABEL_ATTACHMENT');
          }
        },
        {
          value: 'Embedded HTML',
          get label() {
            return localizer.getText('COMMON_LABEL_EMBEDDED_HTML');
          }
        }
      ]
    },
    {
      value: 'File Location',
      get label() {
        return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_FILE_LOCATION');
      },
      deliveryMethod: [
        {
          value: 'Send to disk',
          get label() {
            return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SEND_TO_DISK');
          }
        }
      ]
    }
  ],

  CONTRAINTS: {
    INSTANCE_NAME: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_INSTANCE_NAME_REQUIRED');
        }
      }
    },
    START_DATE: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_START_DATE_REQUIED');
        }
      }
    },
    START_TIME: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_START_TIME_REQUIED');
        }
      }
    },
    DELIVERY_TYPE: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_DELIVERY_TYPE_REQUIED');
        }
      }
    },
    DELIVERY_METHOD: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_DELIVERY_METHOD_REQUIED');
        }
      }
    }
  },

  SUBSCRIPTION_TYPE_VALUES: {
    get subscriptionReport() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_TYPE_REPORTING_ITEM');
    },
    get subscriptionAlert() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SUBSCRIPTION_TYPE_ALERT');
    }
  },

  DELIVERY_METHOD_VALUES: {
    get Attachment() {
      return localizer.getText('COMMON_LABEL_ATTACHMENT');
    }
  },

  DELIVERY_METHOD_VIEW_PATTERN: '{0} ({1})',

  SCHEDULER_TAB: {
    index: 1,
    key: 'schedule'
  },
  DELIVERY_TAB: {
    index: 2,
    key: 'delivery'
  },

  FIELD_KEY: {
    Recipients: 'Recipients',
    StartTime: 'StartTime',
    EndDate: 'EndDate',
    StartDate: 'StartDate'
  },

  SYSTEM_VARIABLES: {
    get TITLE() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SYSTEM_VARIABLES_TITLE');
    },
    get INSTRUCTION() {
      return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SYSTEM_VARIABLES_INSTRUCTION');
    },
    TABLE_DEF: {
      name: {
        columnKey: 'name',
        get title() {
          return localizer.getText('REPORT_SUBCRIPTION_CONSTANT_SYSTEM_VARIABLES_TITLE');
        },
        sortable: true,
        width: 150
      },
      dataType: {
        columnKey: 'dataType',
        get title() {
          return localizer.getText('COMMON_LABEL_DATA_TYPE');
        },
        sortable: true,
        width: 150
      },
      description: {
        columnKey: 'description',
        get title() {
          return localizer.getText('COMMON_LABEL_DESCRIPTION');
        },
        sortable: true,
        width: 160
      }
    },
    DEFAULT_VALUE: {
      get SEARCH_CRITERIA() {
        return localizer.getText('COMMON_LABEL_ALL');
      },
      SORT_DIRS: {
        name: 'ASC'
      }
    }
  },

  ELEMENTS: {
    EMAIL_SUBJECT: {
      KEY: 'subject',
      CLASS: '.email-subject'
    },
    EMAIL_BODY: {
      KEY: 'body',
      CLASS: '.email-body'
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportSubscriptionConstants.js